/**
 * Tronque un texte à une longueur maximale donnée
 * @param {string} text - Le texte à tronquer
 * @param {number} maxLength - La longueur maximale autorisée
 * @returns {string} - Le texte tronqué avec "..." si nécessaire
 */
export const truncate = (text, maxLength) => {
  if (!text) return '';
  
  if (text.length <= maxLength) {
    return text;
  }
  
  return text.substring(0, maxLength) + '...';
};